/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

#consciousness-area {
  .symptoms-list {
    > div.MuiFormControl-root,
    > div.MuiFormGroup-root {
      width: 50%;
    }
  }
}
